// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3119) return "static/chunks/3119-b1f6d87a75644e00.js";
	if (chunkId === 3859) return "static/chunks/3859-40d85e64c72b0cb5.js";
	if (chunkId === 9617) return "static/chunks/9617-1e44b79cdb5d0e01.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2443":"3a37f57c89efb88f","2460":"426bde8e957f0393","2648":"5c5d9cad92bd472e","2823":"281f040a44cc0359","4654":"1ed66992e9c7a3d2","5192":"a2c68cb2d89139a0","5355":"47b228dd7e74874c","7247":"6becfcbb72460ceb","8395":"44d4c14ec2697032","9595":"00d90c508bcece25","9718":"ab343f251743ad93"}[chunkId] + ".js";
};